import GifPageNotFound from '@/assets/gif/page_not_found.gif';
import ArrowUpRightPlain from '@/assets/icons/arrow_up_right_plain.svg';
import { Link } from "wouter";
import { getXDaoHomePath } from "@/lib/utils";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex flex-col justify-between items-center bg-black">
      <div className="w-[17.875rem] text-center mt-9">
        <h3 className="text-xl font-semibold text-white">404 Page Not Found</h3>
        <p className="mt-3 text-sm text-[#9CA3AF]">
          the page are you looking for doesn't exist or has been moved
        </p>
      </div>
      <div className="w-[50rem] flex justify-center">
        <img src={GifPageNotFound} alt="Page Not Found" />
      </div>
      <div className="w-[17.875rem] flex justify-center mb-[5.25rem]">
        <Link href={getXDaoHomePath()} className="bg-[#873ED0] text-white px-5 py-3 rounded-lg font-semibold font-inter flex items-center justify-center">
          Back to Home
          <img src={ArrowUpRightPlain} alt="Arrow Up Right Plain" className="inline-block ml-3 w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
